import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
interface PageTransitionProps {
  children: React.ReactNode;
}
const PageTransition: React.FC<PageTransitionProps> = ({
  children
}) => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [transitionStage, setTransitionStage] = useState('fadeIn');
  useEffect(() => {
    if (location.pathname !== displayLocation.pathname) {
      setTransitionStage('fadeOut');
      setTimeout(() => {
        setDisplayLocation(location);
        setTransitionStage('fadeIn');
      }, 300); // Match the duration in the CSS
    }
  }, [location, displayLocation]);
  return <div className={`transition-opacity duration-300 ${transitionStage === 'fadeIn' ? 'opacity-100' : 'opacity-0'}`} data-id="element-560">
      {children}
    </div>;
};
export default PageTransition;